import React, { Component } from 'react'
import PropTypes from 'prop-types'

import _ from 'lodash'

import { Container, Flex } from '@stackhouse/styled-elements'
import { withDashboardContext, withRouter } from '@stackhouse/dashboard-components/Dashboard'

import Toast from '@stackhouse/dashboard-components/Toast'

import ResponsiveForm from '../components/ResponsiveForm'

import { getFormValue, getFormValueMap } from '../utils/form'


class DetailTemplate extends Component {

    constructor(props) {
        super(props)
        this.formRef = React.createRef()
        this.state = { data: {}, fields: [], openSections: [], hiddenSections: [] }
    }


    static propTypes = {
        formName: PropTypes.string,
        data: PropTypes.object,
        dataEndpoint: PropTypes.string,
        fields: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array,
        ]),
        fieldsEndpoint: PropTypes.string,
        editable: PropTypes.bool,
        resourceId: PropTypes.number,
    }

    static forwardedMethods = [
        'setData'
    ]

    setData = (data, callback) => {
        return this.setState({ data }, callback)
    }

    componentDidMount() {
        return this.loadData()
    }

    loadData = () => {
        const { withLoader, client, dataEndpoint, fieldsEndpoint, formName, params, resourceId, history } = this.props
        return withLoader(done => {

            // Redirect to home if no data and id == 0 (i.e. navigating from search bar)
            if (!this.props.data && !resourceId) {
                history.replace('/')
                return done()
            }

            const data = this.props.data || client.get(`${dataEndpoint}`).then(res => res.data)

            const fieldsEndpointData = { formName, ...params, ...this.props.data }
            const fields = this.props.fields || client.post(`${fieldsEndpoint}`, fieldsEndpointData).then(res => res.data)

            return Promise.all([data, fields]).then(([data, { fieldsConfig, sectionConfig }]) => {
                const hiddenSections = sectionConfig.filter(section => !section.sectionVisible).map(section => section.sectionName)
                const openSections = sectionConfig.filter(section => section.sectionExpanded).map(section => section.sectionName)
                return this.setState({ data, fields: fieldsConfig, openSections, hiddenSections }, this.loaderDone)
            }).then(done).catch(done)
        })
    }

    onChange = (data) => {
        return this.setState({ data })
    }


    setError = (error) => {
        if (this.formRef.current && this.formRef.current.setError) {
            this.formRef.current.setError(error)
        }
    }


    validateAndGetValue = () => {
        const { fields } = this.state

        if (this.formRef.current.isValid()) {
            const { data } = this.state
            return [
                { ...data, ...getFormValue(fields, data) },
                getFormValueMap(fields, data)
            ]
        }
        else {
            const error = this.formRef.current.validate()
            const erroredIds = Object.keys(error).filter(id => !!error[id])
            const erroredFields = erroredIds.map(id => fields.find(field => field.id == id))

            const errorMessage = Object.entries(_.groupBy(erroredFields, 'section')).reduce((acc, [section, sectionFields]) => {
                const title = `${section}:`
                const messages = sectionFields.map(({ id }) => `\t• ${error[id]}`)

                return `${acc}${title}\n${messages.join('\n')}\n`

            }, '')

            if (erroredIds[0]) {
                const firstElement = document.getElementById(erroredIds[0])
                if (firstElement && firstElement.scrollIntoView) {
                    firstElement.scrollIntoView({ behavior: 'smooth' })
                }
            }

            /*
                const { openSections } = this.state
                const uniqueOpenSections = _.uniq(shouldOpenSections.filter(Boolean))

                this.setState({ openSections: _.uniq([...openSections, ...uniqueOpenSections]) })
            */

            Toast.toast({ type: 'error', text: errorMessage, fixed: false }, { overlay: true })
            return null
        }
    }

    render() {
        const { editable } = this.props
        const { fields, openSections, hiddenSections, data } = this.state
        return (
            <Flex column fill>
                <Container flex={0}>
                    <ResponsiveForm
                        ref={this.formRef}
                        readOnly={!editable}
                        value={data}
                        fields={fields}
                        openSections={openSections}
                        hiddenSections={hiddenSections}
                        onChange={this.onChange}
                    />
                </Container>
            </Flex>
        )
    }
}


export default withDashboardContext(withRouter(DetailTemplate), ({ client, withLoader }) => ({ client, withLoader }))
